module.exports = __webpack_public_path__ + "img/my-groups-fill.973d3315.svg";